import { render } from "./Lightbox-Object.vue?vue&type=template&id=51016ba6"
import script from "./Lightbox-Object.vue?vue&type=script&lang=js"
export * from "./Lightbox-Object.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__